import en from "@/assets/images/flags/en.svg";
import fr from "@/assets/images/flags/fr.svg";

export {
    en,
    fr
}

export default {
    en,
    fr
}
